import React from "react";
import "./Rebate_Ratio.css";
import Common_white_header from "../Common/Common_Component/Common_white_header/Common_white_header";
import Rebate_Ratio_card from "./Rebate_Ratio_card/Rebate_Ratio_card";
import No_data from "../Common/No_data/No_data";

function Rebate_Ratio() {
  return (
    <>
      <section className="Rebate_Ratio">
        <Common_white_header headingText={"Rebate Ratio"} />
        <div className="container">
          <Rebate_Ratio_card />
          <Rebate_Ratio_card />
          <Rebate_Ratio_card />
          <Rebate_Ratio_card />
          <Rebate_Ratio_card />
          <Rebate_Ratio_card />

           <No_data/>
        </div>
      </section>
    </>
  );
}

export default Rebate_Ratio;
